<template>
  <vue-plyr ref="plyr" :emit="['playing','pause', 'ready', 'ended', 'timeupdate']" @timeupdate="isPlaying" @ready="isReady" @playing="playTimer" @pause="stopTimer" @ended="videoEnd">
    <div class="plyr__video-embed">
      <iframe
        :src="getYoutubeUrl"
        allowfullscreen allowtransparency allow="autoplay">
      </iframe>
    </div>
  </vue-plyr>
</template>

<script>
export default {
  props: {
    videoId: String,
  },

  watch: {
    videoId() {
      this.$emit('update', this.getPlayer)
    }
  },

  computed: {
    getYoutubeUrl() {
      return `https://www.youtube.com/embed/${this.videoId}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`
    },

    getPlayer() {
      return this.$refs.plyr.player
    },
  },

  methods: {
    isReady() {
      this.$emit('ready', this.getPlayer)
    },

    playTimer() {
      this.$emit('play')
    },

    stopTimer() {
      this.$emit('stop')
    },

    videoEnd() {
      this.$emit('end')
    },

    isPlaying() {
      this.$emit('playing')
    }
  },
}
</script>
